export const ACTIVATE_GREEN_LIGHT = 'cardReader/ACTIVATE_GREEN_LIGHT';
export const ACTIVATE_CARD_LIGHT = 'cardReader/ACTIVATE_CARD_LIGHT';
export const DEACTIVATE_GREEN_LIGHT = 'cardReader/DEACTIVATE_GREEN_LIGHT';
export const DEACTIVATE_CARD_LIGHT = 'cardReader/DEACTIVATE_CARD_LIGHT';

export const SET_CURRENT_ZONE = 'cardReader/SET_CURRENT_ZONE';
export const SET_TICKET_ZONES = 'cardReader/SET_TICKET_ZONES';
export const SET_TICKET_PASSENGERS = 'cardReader/SET_TICKET_PASSENGERS';
export const SET_SEASONAL_TICKET_ZONES = 'cardReader/SET_SEASONAL_TICKET_ZONES';

export const BEEP = 'cardReader/BEEP';
export const RESET = 'cardReader/RESET';

export const activateGreenLight = () => ({ type: ACTIVATE_GREEN_LIGHT });
export const activateCardLight = () => ({ type: ACTIVATE_CARD_LIGHT });
export const deactivateGreenLight = () => ({ type: DEACTIVATE_GREEN_LIGHT });
export const deactivateCardLight = () => ({ type: DEACTIVATE_CARD_LIGHT });

export const setCurrentZone = (zone) => ({
  type: SET_CURRENT_ZONE,
  payload: zone,
});

export const setTicketZones = (ticketType, zones) => ({
  type: SET_TICKET_ZONES,
  payload: { ticketType, zones },
});

export const setTicketPassengers = (ticketType, passengers) => ({
  type: SET_TICKET_PASSENGERS,
  payload: { ticketType, passengers },
});

export const setSeasonalTicketZones = (ticketType, seasonalTicketZones) => ({
  type: SET_SEASONAL_TICKET_ZONES,
  payload: { ticketType, seasonalTicketZones },
});

export const beep = () => ({ type: BEEP });
export const reset = () => ({ type: RESET });
